import { gql } from 'graphql-request'

export const createOrderRecipe = gql`
    mutation createOrderRecipe(
        $orderId: ID!
        $recipe: ID!
        $sideDishes: [InputOrderRecipeSideDishCreate!]
        $amount: Int!
        $note: String!
        $wareCategoryId: ID
        $promoTag: PromoTagEnum
    ) {
        createOrderRecipe(
            orderRecipe: {
                order: $orderId
                recipe: $recipe
                amount: $amount
                sideDishRecipes: $sideDishes
                note: $note
                wareCategory: $wareCategoryId
                promoTag: $promoTag
            }
        ) {
            id
        }
    }
`
